import { FlexRow } from "@/components/flex-row";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "@/components/ui/item";
import { Progress } from "@/components/ui/progress";
import { AbsoluteDate, RelativeDate } from "@/components/utils/date-utils";
import {
  CarIcon,
  ClockIcon,
  SquarePenIcon,
  Trash2Icon,
  UserIcon,
} from "lucide-react";

function DraftSummaryCard({
  name,
  kvps,
  vehiculeName,
  vehiculeVin,
  client,
  lastModified,
  expiryDate,
  currentStep,
  steps = 7,
  author,
  createdAt,
  onEdit,
  onDelete,
}: {
  name: string;
  kvps: string;
  vehiculeName: string;
  vehiculeVin: string;
  client: string;
  lastModified: Date;
  expiryDate: Date;
  currentStep: number;
  steps?: number;
  author: string;
  createdAt: Date;
  onEdit?: () => void;
  onDelete?: () => void;
}) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-row gap-4">
          <span className="font-bold">{name}</span>
          <Badge className="font-bold" variant="outline">
            KVPS : {kvps}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-4 items-start">
          <Item>
            <ItemMedia>
              <CarIcon className="text-primary" />
            </ItemMedia>
            <ItemContent>
              <span className="text-sm text-gray-600">Véhicule</span>
              <ItemTitle>{vehiculeName}</ItemTitle>
              <ItemDescription>{vehiculeVin}</ItemDescription>
            </ItemContent>
          </Item>

          <Item>
            <ItemMedia>
              <UserIcon className="text-primary" />
            </ItemMedia>
            <ItemContent>
              <span className="text-sm text-gray-600">Client</span>
              <ItemTitle>{client}</ItemTitle>
              <ItemDescription>&nbsp;</ItemDescription>
            </ItemContent>
          </Item>

          <Item>
            <ItemMedia>
              <ClockIcon className="text-primary" />
            </ItemMedia>
            <ItemContent>
              <span className="text-sm text-gray-600">
                Dernière modification
              </span>
              <ItemTitle>
                <AbsoluteDate date={lastModified} />
              </ItemTitle>
              <ItemDescription>
                Expire <RelativeDate date={expiryDate} />
              </ItemDescription>
            </ItemContent>
          </Item>

          <Item>
            <ItemContent>
              <span className="text-sm text-gray-600">Modification</span>
              <FlexRow className="gap-2">
                <Progress value={(currentStep / steps) * 100} />
                <span className="text-sm whitespace-nowrap text-gray-600">
                  {currentStep} / {steps}
                </span>
              </FlexRow>
            </ItemContent>
          </Item>
        </div>
      </CardContent>
      <CardFooter>
        <FlexRow className="w-full">
          <span>
            Créé par <span className="font-semibold">{author}</span> le{" "}
            <AbsoluteDate date={createdAt} />
          </span>

          <ButtonGroup>
            <Button onClick={() => onEdit?.()}>
              <SquarePenIcon />
              Reprendre
            </Button>
            <Button onClick={() => onDelete?.()} variant="destructive">
              <Trash2Icon />
              Supprimer
            </Button>
          </ButtonGroup>
        </FlexRow>
      </CardFooter>
    </Card>
  );
}

export { DraftSummaryCard };
